import axiosInstance from "@/utils/axiosInstance";
import store from "@/store";

const baseUrl = `api/companies`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getContacts({ commit }, payload: {
    id: number,
    query: any,
    search?: string,
    page?: number,
    itemsPerPage?: number,
  }) {

    const query = JSON.parse(JSON.stringify(payload.query));
    if (payload.search && !query.search) { query.search = payload.search; }
    if (payload.page && !query.page) { query.page = payload.page; }
    if (payload.itemsPerPage && !query.itemsPerPage) { query.itemsPerPage = payload.itemsPerPage; }

    return axiosInstance.get(`${baseUrl}/${payload.id}/contacts`, { params: query })
      .then((data) => data.data);
  },
  updateContact({ commit }, payload: { companyId: number, contactId: number, contact: object }) {
    return axiosInstance.put(`${baseUrl}/${payload.companyId}/contacts/${payload.contactId}`, {
      contact: payload.contact,
    }).then((data) => data.data);
  },
  addContact({ commit }, payload: {
    companyId: number,
    contact: object,
  }) {
    return axiosInstance.post(`${baseUrl}/${payload.companyId}/contacts`, payload)
      .then((data) => data.data);
  },
  deleteContacts({ commit }, payload: { companyId: number, contactsIds: number[] }) {
    return axiosInstance.post(`${baseUrl}/${payload.companyId}/delete-contacts`, {
      contactsIds: payload?.contactsIds,
    }).then((data) => data.data);
  },
  getSubordinates({ commit }, payload: { id: number, query: object }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/subordinates`, { params: payload?.query })
      .then((data) => data.data);
  },
  getNonTransferables({ commit }, payload: { id: number, query: object }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/non-transferables`, { params: payload?.query })
      .then((data) => data.data);
  },
  addSubordinate({ commit }, payload: { companyId: number, subordinate: object }) {
    return axiosInstance.post(`${baseUrl}/${payload.companyId}/subordinates`, { subordinate: payload?.subordinate })
      .then((data) => data.data);
  },
  deleteSubordinates({ commit }, payload: { companyId: number, subordinatesIds: number[] }) {
    return axiosInstance.post(`${baseUrl}/${payload.companyId}/delete-subordinates`, {
      subordinatesIds: payload?.subordinatesIds,
    }).then((data) => data.data);
  },
  getContactsAndSubordinates({ commit }, payload: {
    id: any,
    query: any,
    search?: string,
    page?: number,
    itemsPerPage?: number,
  }) {
    let query: any = {};
    if (payload?.query) {
      query = JSON.parse(JSON.stringify(payload.query));
    }
    if (payload.search && !query.search) { query.search = payload.search; }
    if (payload.page && !query.page) { query.page = payload.page; }
    if (payload.itemsPerPage && !query.itemsPerPage) { query.itemsPerPage = payload.itemsPerPage; }

    return axiosInstance.get(`${baseUrl}/${payload.id}/contacts-subordinates`, { params: query })
      .then((data) => data.data);
  },
  getUserGroups({ commit }, payload: { id: number, query: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/user-groups`, {
      params: payload.query,
    }).then((data) => data.data);
  },
  getOverpriceLimit({ commit }, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/overprice-limit`)
      .then((data) => data.data);
  },
  updateOverpriceLimit({ commit }, payload: { id: number, overpriceLimit: number }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/overprice-limit`, { overpriceLimit: payload.overpriceLimit })
      .then((data) => data.data);
  },
  getSmsRemaining({ commit }, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/sms-remaining`)
      .then((data) => data.data);
  },
  getCompanyBuildingList({ commit }, payload: {
    companyId: number, search: string | null, page: number, itemsPerPage: number, notLinkToRelay: boolean | null,
    buildingId: number | null,
  }) {
    return axiosInstance.get(`api/companies/${payload.companyId}/buildings`, {
      params: {
        search: payload.search, page: payload.page,
        itemsPerPage: payload.itemsPerPage, notLinkToRelay: payload.notLinkToRelay,
        buildingId: payload.buildingId,
      },
    }).then((data) => data.data);
  },
  getCompanyBuildingTransfers({ commit }, payload: {
    companyId: number,
    buildingId?: number,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.companyId}/buildings-transfers`, {
      params: {
        buildingId: payload.buildingId,
      },
    }).then((data) => data.data);
  },
  // use in key creation and key edition, search "storePathFn"
  getCompanyBuildingSoloList({ commit }, payload: {
    companyId: number, search: string | null, page: number, itemsPerPage: number,
  }) {
    return axiosInstance.get(`api/companies/${payload.companyId}/buildings`, {
      params: {
        search: payload.search, page: payload.page, itemsPerPage: payload.itemsPerPage, notLinkToRelay: true,
      },
    }).then((data) => data.data);
  },
  getRelaysFilterList({ commit }, payload: { companyId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.companyId}/relays-filter-list`)
      .then((data) => data.data);
  },
  getRelays({commit}, payload: {companyId: number, query: object}) {
    return axiosInstance.get(`${baseUrl}/${payload.companyId}/relays`, {
      params: payload.query,
    }).then((data) => data.data);
  },
  getServiceCompaniesList({ commit }, payload: {
    companyId: number,
    search: string | null,
    page: number,
    itemsPerPage: number,
  }) {
    return axiosInstance.get(`api/companies/${payload.companyId}/service-companies`, {
      params: {
        search: payload.search,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
      },
    }).then((data) => data.data);
  },
  addServiceCompany({ commit }, payload: {
    clientCompanyId: number,
    serviceCompanyId: number,
  }) {
    return axiosInstance.post(`api/companies/${payload.clientCompanyId}/service-companies/${payload.serviceCompanyId}`)
      .then((data) => data.data);
  },
  inviteServiceCompany({ commit }, payload: {
    clientCompanyId: number,
    siret: string,
    clientCompanyName: string
    masterEmail: number,
    serviceCompanyName: string,
    serviceCompanyActivitySector: string,
    serviceCompanyAddress: string,
    serviceCompanyCity: string,
    serviceCompanyZipCode: string,
    serviceCompanyCountry: string,
    serviceCompanyContactName: string,
    serviceCompanyContactPhone: string,
  }) {
    return axiosInstance.post(`api/companies/${payload.clientCompanyId}/service-companies/invite`, {
      siret: payload?.siret,
      masterEmail: payload?.masterEmail,
      clientCompanyName: payload?.clientCompanyName,
      serviceCompanyName: payload?.serviceCompanyName,
      serviceCompanyActivitySector: payload?.serviceCompanyActivitySector,
      serviceCompanyAddress: payload?.serviceCompanyAddress,
      serviceCompanyCity: payload?.serviceCompanyCity,
      serviceCompanyZipCode: payload?.serviceCompanyZipCode,
      serviceCompanyCountry: payload?.serviceCompanyCountry,
      serviceCompanyContactName: payload?.serviceCompanyContactName,
      serviceCompanyContactPhone: payload?.serviceCompanyContactPhone,
    }).then((data) => data.data);
  },
  removeServiceCompany({ commit }, payload: {
    clientCompanyId: number,
    serviceCompanyId: number,
  }) {
    return axiosInstance.delete(
      `api/companies/${payload.clientCompanyId}/service-companies/${payload.serviceCompanyId}`,
    ).then((data) => data.data);
  },
  readById({ commit }, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  findByIds({ commit }, payload: { ids: number[] }) {
    return axiosInstance.get(`${baseUrl}/find`, {
      params: {
        ids: payload.ids,
      },
    }).then((data) => data.data);
  },
  findOne({ commit }, payload: { siret: string }) {
    return axiosInstance.get(`${baseUrl}/find-one`, {
      params: {
        siret: payload.siret,
      },
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
